
import type React from "react"
import { useTheme } from "../contexts/ThemeContext"
import { useTranslation } from "../hooks/useTranslation"
import { getLocalizedTextFromApiResponse } from "../features/menu/menuSlice"

interface BottomProps {
  activeCategory: string | number
  setActiveCategory: (category: string | number) => void
  categories: Array<{
    id: number
    name: string | { ar?: string; en?: string }
    name_ar?: string
    name_en?: string
    image: string
    products: any[]
  }>
}

const Bottom: React.FC<BottomProps> = ({ activeCategory, setActiveCategory, categories }) => {
  const { primaryColor } = useTheme()
  const { currentLanguage: language } = useTranslation()

  const getCategoryName = (category: any) => {
    return getLocalizedTextFromApiResponse(category, 'name', language, 'ar')
  }

  return (
    <div className="">
      <div className="flex overflow-x-auto pt-5 scrollbar-hide">
        {categories.map((category) => {
          const categoryName = getCategoryName(category)
          const isActive = activeCategory === category.id || activeCategory === categoryName

          return (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id || categoryName)}
              className={` mr-1 px-5 sm:px-6 md:px-8 py-2  rounded-3xl sm:rounded-3xl  text-sm sm:text-base md:text-lg font-semibold whitespace-nowrap shadow-xs transition-all duration-300 transform  ${isActive
                  ? "text-white "
                  : "bg-white text-gray-700 border border-gray-200"
                }`}
              style={isActive ? { backgroundColor: primaryColor } : {}}
            >
              {categoryName}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default Bottom
